export default "__VITE_ASSET__DfBucf3u__"